import * as React from "react"
import {CheckboxProps, DropdownProps, Form, InputOnChangeData} from "semantic-ui-react"
import {Locale} from "../model/BookingTypes"
import {CommonPlacesLocale} from "./CommonPlacesLocale"
import {ScratchCommonPlace} from "../model/places/PlaceTypes"
import {ID} from "../model/id"
import {PlaceCategory} from "../graphql/queries"
import {InfoModalButton} from "./InfoModal"
import {WithModalStore} from "../App"
import {MessageModal} from "./MessageModal"
import {onUpsertCommonPlaceMutation} from "./CommonPlacesAdmin"

// TODO See CREATE TYPE place_category AS ENUM ('Place', 'Airport', 'Hospital') in DB
const categoryOptions = [
  {text: "Place", value: "Place"},
  {text: "Airport", value: "Airport"},
  {text: "Hospital", value: "Hospital"},
]

interface Props extends WithModalStore {
  commonPlace: ScratchCommonPlace
  defaultLocale: Locale
  searchPlaceId: ID | null
  setCommonPlace: (x: Partial<ScratchCommonPlace> | null) => void
}

export class CommonPlaceForm extends React.Component<Props, {}> {
  handleSave = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault()

    const {
      commonPlace,
      commonPlace: {placeId, label},
    } = this.props

    if (placeId && label) {
      this.modalStore.handlePromiseThrow(
        this.onUpsert(placeId, this.defaultLocaleId(), commonPlace).then(() => this.onReset()),
      )
    } else {
      this.onValidationFailure()
    }
  }

  handleReset = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault()
    this.onReset()
  }

  defaultLocaleId = () => this.props.commonPlace.localeId || this.props.defaultLocale.id

  render() {
    const {
      commonPlace: {placeId, label, shortLabel, suggest, category},
      searchPlaceId,
    } = this.props

    const disabledCopyButton = !searchPlaceId || searchPlaceId === placeId

    return (
      <div>
        <CommonPlacesLocale
          localeId={this.defaultLocaleId()}
          onLocale={this.onLocale}
          disabled={true}
        />
        <Form.Field required>
          <label>Label</label>
          <Form.Input placeholder="Label" value={label} onChange={this.onLabel} />
        </Form.Field>
        <Form.Field>
          <label>Short label</label>
          <Form.Input placeholder="Short label" value={shortLabel} onChange={this.onShortLabel} />
        </Form.Field>
        <Form.Group>
          <Form.Field>
            <label>Category</label>
            <Form.Select options={categoryOptions} value={category} onChange={this.onCategory} />
          </Form.Field>
          <Form.Field>
            <label>Suggest?</label>
            <Form.Checkbox checked={suggest} onChange={this.onSuggest} />
          </Form.Field>
        </Form.Group>
        <Form.Group>
          <Form.Field required>
            <label>Place ID</label>
            <Form.Input disabled={true} readOnly value={placeId} />
          </Form.Field>
        </Form.Group>
        <Form.Group>
          <Form.Button onClick={this.onPlaceId} disabled={disabledCopyButton}>
            Copy ID from "Place Search"
          </Form.Button>
          <Form.Button positive onClick={this.handleSave}>
            Save
          </Form.Button>
          <Form.Button onClick={this.handleReset}>Reset</Form.Button>
        </Form.Group>
      </div>
    )
  }

  get modalStore() {
    return this.props.modalStore
  }

  get commonPlace() {
    return this.props.commonPlace
  }

  onPlaceId = () => {
    const {searchPlaceId} = this.props
    if (searchPlaceId) {
      this.props.setCommonPlace({placeId: searchPlaceId})
    }
  }
  onLocale = (locale: Locale) => {
    this.props.setCommonPlace({localeId: locale.id})
  }
  onLabel = (e: any, field: InputOnChangeData) => {
    this.props.setCommonPlace({label: field.value})
  }
  onShortLabel = (e: any, field: InputOnChangeData) => {
    this.props.setCommonPlace({shortLabel: field.value})
  }
  onCategory = (e: React.SyntheticEvent<HTMLElement>, field: DropdownProps) => {
    this.props.setCommonPlace({category: field.value as PlaceCategory})
  }
  onSuggest = (e: React.FormEvent<HTMLInputElement>, field: CheckboxProps) => {
    this.props.setCommonPlace({suggest: field.checked as boolean})
  }
  onReset = () => {
    this.props.setCommonPlace(null)
  }
  onUpsert = (placeId: ID, localeId: ID, commonPlace: ScratchCommonPlace) => {
    return this.modalStore.applyModal({
      pending: ["Message", "Saving..."],
      error: (m) => ["Message", "Insert/update failed." + (m ? ` ${m}.` : "")],
      ok: () => ["Message", "Insert/update successful."],
      action() {
        return onUpsertCommonPlaceMutation({
          commonPlace: {
            ...commonPlace,
            placeId,
            localeId,
          },
        })
      },
    })
  }
  onValidationFailure = () => {
    this.modalStore.showModal(MessageModal, {
      modalStore: this.modalStore,
      heading: "Message",
      message: "Please supply a Place ID and a label.",
      button: InfoModalButton.OK,
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/CommonPlaceForm.tsx